import "./styles/base.css";
import "./styles/access.css";
import "./styles/layout.css";

import CologuardErrorBoundary from "./components/CologuardErrorBoundary.jsx";
import FeedbackProvider from "./components/FeedbackProvider.jsx";
import CologuardPage from "./pages/CologuardPage.jsx";

export default function CologuardRoot() {
  return (
    <CologuardErrorBoundary>
      <FeedbackProvider>
        <CologuardPage />
      </FeedbackProvider>
    </CologuardErrorBoundary>
  );
}
